/**
 * アプリ共通機能
 */
'use strict';
import { ApiSingle } from "./api-single.js";

/**
 * 共通ツールパレット表示制御
 * @param {boolean} show 可視フラグ
 */
const showCommonTools = function(show = true, showControls)
{
    if(show) {
        $('#commonTools').removeClass('d-none');
    }
    else {
        $('#commonTools').addClass('d-none');
    }
    $('.common-tool-btn').addClass('d-none');
    for(let i = 0; i < showControls.length; i++) {
        $('#' + showControls[i]).removeClass('d-none');
    }
}

/**
 * サイドメニューボタン表示制御
 * @param {boolean} show 可視フラグ
 */
const showSideMenuButtons = function(show = true, showControls)
{
    if(show) {
        $('.side-btn-area').removeClass('d-none');
    }
    else {
        $('.side-btn-area').addClass('d-none');
    }
    $('.side-btn').addClass('d-none');
    for(let i = 0; i < showControls.length; i++) {
        $('#' + showControls[i]).removeClass('d-none');
    }
    // サイドメニュー領域サイズ調整
    adjustSideMenuAreaSize()
}

/**
 * サイドメニュー領域サイズ調整
 */
const adjustSideMenuAreaSize = function()
{
    // サイドメニュー
    let ofsSideMenuDiv = $('#side-menu-division').offset()
    let ofsSideBtnArea = $('.side-btn-area').offset()
    if((undefined !== ofsSideMenuDiv) && (undefined !== ofsSideBtnArea)) {
        let cy = (ofsSideBtnArea.top - ofsSideMenuDiv.top)
        //console.log(cy + 'px')
        $('.side-menu-area').css('max-height', cy + 'px')
    }
}

/**
 * 学期名称作成
 */
const makeTermName = function (term_kind, term)
{
    let termName = "";
    if(CommonConsts.TERM_KIND_2TERMS == term_kind) {
        switch(term) {
            case CommonConsts.TERM_1:
                termName = "前期";
                break;
            case CommonConsts.TERM_2:
                termName = "後期";
                break;
        }
    }
    else {
        switch(term) {
            case CommonConsts.TERM_1:
                termName = "１学期";
                break;
            case CommonConsts.TERM_2:
                termName = "２学期";
                break;
            case CommonConsts.TERM_3:
                termName = "３学期";
                break;
        }
    }
    return termName;
}

/**
 * AJAXでJSONに登録するDB日付フォーマット文字列を生成
 * @param {number} year 
 * @param {number} month 
 * @param {number} day 
 * @param {number} hour 
 * @param {number} min 
 * @param {number} sec 
 * @returns DB日付フォーマット
 */
const makeDBDateTime = function(year, month, day, hour, min, sec)
{
    return zeroPadding(year, 4) + "-" 
        + zeroPadding(month, 2) + "-" 
        + zeroPadding(day, 2) + " " 
        + zeroPadding(hour, 2) + ":" 
        + zeroPadding(min, 2) + ":" 
        + zeroPadding(sec, 2);
}

/**
 * 数値のゼロ詰め書式化（10桁まで保証）
 * @param {number} num 
 * @param {number} zeroNum 
 * @returns ゼロ詰め書式化された数値文字列
 */
const zeroPadding = function(num, zeroNum)
{
    return ("0000000000" + num).slice(-1 * zeroNum);
}

/**
 * ラストクラス名を記録
 * ※nullを指定するとクリア
 */
const setLastClassName = function(className = null)
{
    //console.log("setLastClassName:" + className)
    localStorage.setItem('last.className', className)
}

/**
 * ラストクラス名を参照
 */
const getLastClassName = function()
{
    let className = localStorage.getItem('last.className')
    //console.log("getLastClassName:" + className)
    return className
}

/**
 * ラスト単元idを記録
 * ※nullを指定するとクリア
 */
const setLastChapterId = function(chapterId = null)
{
    localStorage.setItem('last.chapterId', chapterId);
}

/**
 * ラスト単元idを参照
 */
const getLastChapterId = function()
{
    let chapterId = localStorage.getItem('last.chapterId');
    return chapterId;
}

/**
 * ラスト教科idを記録
 * ※nullを指定するとクリア
 */
const setLastSubjectId = function(subjectId = null)
{
    //console.log("setLastSubjectId:" + subjectId)
    localStorage.setItem('last.subjectId', subjectId)
}

/**
 * ラスト教科idを参照
 */
const getLastSubjectId = function()
{
    let subjectId = localStorage.getItem('last.subjectId')
    //console.log("getLastSubjectId:" + subjectId)
    return subjectId;
}

/**
 * 日時フォーマット
 * @param {number} year 
 * @param {number} mon 
 * @param {number} day 
 * @param {number} hour 
 * @param {number} min 
 * @param {number} sec 
 * @returns 
 */
const formatDateTime = function (year, mon, day, hour = 0, min = 0, sec = 0)
{
    return ("" + paddingZero(year,4) + "-" + paddingZero(mon,2) + "-" + paddingZero(day,2) + " " + paddingZero(hour,2) + ":" + paddingZero(min,2) + ":" + paddingZero(sec,2));
}

/**
 * ゼロパディング：日時フォーマット専用
 * @param {number} num 数値
 * @param {number} keta 桁数
 * @returns 
 */
function paddingZero(num, keta)
{
    return ('0000' + num).slice(-1 * keta);
}

// URLをクリップボードにコピーする
//  もともとは navigator.clipboard.writeText(""); で実装していたが、HTTPだとできないので修正
//  document.execCommand が非推奨関数なので怖い
const copyText2Clipboard = function(id)
{
    if( navigator.clipboard ) {
        // Clipboard API が有効ならこちら
        //console.log("navigator.clipboard Enable!");
        navigator.clipboard.writeText($("#" + id).val());
    }
    else {
        // Clipboard API が無効ならこちら
        //console.log("navigator.clipboard Disable!");
        var target = null;
        var p = null;
        window.getSelection().removeAllRanges();
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            target = document.querySelector('#' + id);
            target.contentEditable  = true;
            target.readOnly = false;
        } else {
            p = document.createElement('p');
            p.setAttribute('id', 'target')
            document.body.appendChild(p);
            p.innerHTML = $('#' + id).val();
            target = document.querySelector('#target');
        }
        var range = document.createRange();
        range.selectNode(target);
        window.getSelection().addRange(range);
        document.execCommand("copy");
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            target.contentEditable  = false;
            target.readOnly = true;
        } else {
            document.body.removeChild(p);
        }
        window.getSelection().removeAllRanges();
    }
}

const getClipboardText = async function()
{
    if( navigator.clipboard ) {
        // Clipboard API が有効ならこちら
        //console.log("navigator.clipboard Enable!");
        const items = await navigator.clipboard.readText();
        return items;
    }
    else {
        //throw "HTTP環境ではクリップボードからデータ取得できません。";
        //console.warn("HTTP環境ではクリップボードからデータ取得できません。");
        return "";
    }    
}

/**
 * 文字列の改行コードを\nに統一し、改行コード（\n, \r\n, \r）の違いを吸収
 * \r\n → \n, \r → \n に変換
 */
function equalizeStrLineBreaks(str)
{
    return str.replace(/\r\n|\r|\n/g, "\n");
}

/**
 * 確認ダイアログ表示関数
 * @param {boolean} bCancel true:cancelボタン表示 false:calcelボタン非表示
 * @returns result モーダル画面でクリックしたボタンの値（1：はい/0：いいえ/-1：キャンセル）
 */
const confirmYesNoCancel = async function(title, content, bCancel = true)
{
    // モーダル画面：タイトル
    $('#confirmDialogTitle').html(title);

    // モーダル画面：本文
    $('#confirmDialogContent').html(content);

    // bCancel = false 時 ,キャンセルボタン非表示
    if(bCancel) {
        $('#buttonRoleCancel').removeClass('d-none');
    }
    else {
        $('#buttonRoleCancel').addClass('d-none');
    }

    // モーダル表示
    $('#confirmDialog').trigger('click');

    // モーダル内のボタンが押下されるまで、ここで処理を停止する
    let buttonId = 'buttonRoleClose';
    await waitForClick(buttonId);

    // モーダル画面でクリックしたボタンの値を取得
    let result = $('#buttonClickResult').val();

    return result;
}

/**
 * モーダル内のボタンIDで指定されたボタンがクリックされるまで、処理を停止させる
 */
function waitForClick(buttonId)
{
    return new Promise(resolve => $('#' + buttonId).on('click', resolve));
}

/**
 * メッセージボックス
 * @param {*} content メッセージ内容
 * @param {*} level メッセージレベル（以下のいずれか）
 * CommonConsts.LEVEL_INFO  情報
 * CommonConsts.LEVEL_WARN  警告（入力ミス・手順不正など）
 * CommonConsts.LEVEL_ERROR 致命的エラー（システム要因などリカバリ不可なエラー）
 * @param {*} title null：levelのデフォルトタイトルが入る
 */
const messageBox = function(content, level, title = null)
{
    // メッセージボックスを表示する
    openMessageBox(content, level, title);
}

/**
 * メッセージボックス
 * （メッセージボックスを表示後、メッセージボックス内の「閉じる」ボタンがクリックされるまで処理を停止する）
 * @param {*} content 
 * @param {*} level 
 * @param {*} title 
 */
const messageBoxWaitForCloseClick = async function(content, level, title = null)
{
    // メッセージボックスを表示する
    openMessageBox(content, level, title);

    // メッセージボックス内の「閉じる」ボタンが押下されるまで、ここで処理を停止する
    let buttonId = 'buttonMsgBoxClose';
    await waitForClick(buttonId);
}

/**
 * メッセージボックスを表示する
 */
function openMessageBox(content, level, title = null)
{
    let icon = '';
    let color = '';
    let defTitle = '';
    switch(level) {
        case CommonConsts.LEVEL_ERROR:
            icon = 'fas fa-exclamation-circle';
            color = 'rgb(255, 0, 0)';
            defTitle = '警告';
            break;
        case CommonConsts.LEVEL_WARN:
            icon = 'fas fa-exclamation-triangle';
            color = 'rgb(255,128,0)';
            defTitle = '注意';
            break;
        default:
            icon = 'fas fa-info-circle';
            color = 'rgb(0,128,255)';
            defTitle = '情報';
            break;
    }
    //console.log("messageBox:" + level);

    // モーダル画面：タイトル
    $('#msgBoxTitle').html(null != title ? title : defTitle);

    // モーダル画面：本文
    $('#msgBoxContent').html(content);

    // モーダル画面：アイコン
    $('#msgBoxIcon').html('<i class="' + icon + '" style="font-size: x-large; color: ' + color + '"></i>');

    // モーダル表示
    $('#modalMsgBox').trigger('click');
}

/**
 * モーダルを閉じる
 */
const closeModal = function(modalName)
{
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    $('#' + modalName).hide();
}

/**
 * 引数に指定したjquery要素に指定イベントを登録する
 */
const registerEventListener = function(element, eventName ,funcReference)
{
    element.off(eventName, funcReference).on(eventName, funcReference);
}

/**
 * サイドナビの幅を取得
 */
const getSideNavWidth = function()
{
    let cxSideNavi = $('#side-menu-division').width() + CommonConsts.SIDE_NAVI_ADUJUST_VALUE
    //console.log("cxSideNavi:" + cxSideNavi)
    return cxSideNavi
}

/**
 * 学期名を取得
 */
const getTermName = function(term)
{
    let termName = '';
    if(CommonConsts.TERM_1 == term)
    {
        termName = '１学期';
    }
    else if(CommonConsts.TERM_2 == term)
    {
        termName = '２学期';
    }
    else if(CommonConsts.TERM_3 == term)
    {
        termName = '３学期';
    }
    return termName;
}

/**
 * 学年・教科・教科書を指定し、テストマスタから「教科書一覧」及び「テストの種類一覧」を配列で取得
 * @param {*} grade 
 * @param {*} subjectId 
 * @param {*} publisherId 
 * @param {*} testMasters 
 * @returns 
 */
const getPublishersAndTestkinds = function(grade, subjectId, publisherId, testMasters)
{
    let publishers = [];
    let testKinds = [];
    for(let i = 0; i < testMasters.length; i++)
    {
        let bPublisher = (testMasters[i].grade == grade) && (testMasters[i].subject_master_id == subjectId);
        let isAllManageClass = (0 == grade) && (testMasters[i].subject_master_id == subjectId);
        if(bPublisher || isAllManageClass)
        {
            let publisher = null;
            if(publishers.length) publisher = publishers.find(elm => elm.publisher_id == testMasters[i].publisher.id);
            let exists = (publisher != null) ? true : false;

            if(!exists)
            {
                publishers.push({
                    'publisher_id' : testMasters[i].publisher.id,
                    'publisher_name' : testMasters[i].publisher.name,
                })
            }
        }

        let bTestKind = (testMasters[i].grade == grade) && (testMasters[i].subject_master_id == subjectId) && (testMasters[i].publisher_id == publisherId);
        isAllManageClass = (0 == grade) && (testMasters[i].subject_master_id == subjectId) && (testMasters[i].publisher_id == publisherId);
        if(bTestKind || isAllManageClass)
        {
            let testKind = null;
            if(testKinds.length) testKind = testKinds.find(elm => elm.test_name_id == testMasters[i].test_name_id);
            let exists = (testKind != null) ? true : false;

            if(!exists)
            {
                testKinds.push({
                    'test_name_id' : testMasters[i].test_name_id,
                    'master_test_no' : testMasters[i].master_test_no,
                    'test_name' : testMasters[i].test_name.name,
                })
            }
        }
    }

    // 教科書一覧を教科書ID順にソート
    if(publishers.length)
    {
        publishers.sort(function(elm1, elm2){
            if(elm1.publisher_id < elm2.publisher_id) return -1;
            if(elm1.publisher_id > elm2.publisher_id) return 1;
            return 0;    
        });
    }

    // テストの種類一覧をテスト名ID順にソート
    if(testKinds.length)
    {
        testKinds.sort(function(elm1, elm2){
            if(elm1.test_name_id < elm2.test_name_id) return -1;
            if(elm1.test_name_id > elm2.test_name_id) return 1;
            return 0;    
        });
    }
    return {'publishers' : publishers, 'testKinds' : testKinds};
}

/**
 * 指定クラス教科の単元に採点が存在するかを確認する
 * @param {*} schoolClassId 
 * @param {*} subjectId 
 * @param {*} chapterIds 
 */
const isChaptersMarksExist = async function(schoolClassId, subjectId, chapterIds = [])
{
    let result = true; // デフォルトは採点が存在する:true で設定しておく
    let markExists = false;
    const apiSingle = new ApiSingle();
    let info = await apiSingle.getClassSubjectChaptersMarks(schoolClassId, subjectId, chapterIds, true);
    if('OK' == info.result)
    {
        let classSubjectChaptersMarks = info.data;
        for(let i = 0; i < classSubjectChaptersMarks.length; i++)
        {
            let markDatas = classSubjectChaptersMarks[i].mark_datas;
            if(null != markDatas)
            {
                for(let j = 0; j < markDatas.length; j++)
                {
                    let markData = markDatas[j].hasOwnProperty('scores') ? markDatas[j].scores : [];
                    for(let k = 0; k < markData.length; k++)
                    {
                        let mark = Number(markData[k]);
                        if((CommonConsts.MARK_DATA_EMPTY != mark) && (CommonConsts.MARK_DATA_UNANSWERED != mark))
                        {
                            markExists = true;
                            break;
                        }
                    }
                    if(markExists) break;
                }
            }
            if(markExists) break;
        }
    }
    // 採点が存在しない場合
    if(!markExists)
    {
        result = false;
    }
    return result;
}

/**
 * 単元設定の設問jsonから、観点名一覧を取得する
 * @param {*} questionsJson 
 * @param {*} viewpointMasters 
 */
const getViewpointNamesFromQJson = function(questionsJson, viewpointMasters, isNameVeryShort = false)
{
    let viewpointNames = [];
    if(null != questionsJson)
    {
        for(let i = 0; i < questionsJson.length; i++)
        {
            let viewpointId = questionsJson[i].viewpoint_id;
            let viewpointMaster = viewpointMasters.find(elm => elm.viewpoint_id == viewpointId);
            if(viewpointMaster !== undefined)
            {
                let exists = false;
                if(viewpointNames.length)
                {
                    let viewpointName = viewpointNames.find(elm => elm.viewpoint_id == viewpointMaster.viewpoint_id);
                    if(viewpointName !== undefined)
                    {
                        exists = true;
                    }
                }
                if(!exists)
                {
                    let viewpointName = isNameVeryShort ? viewpointMaster.name_very_short : viewpointMaster.name_short;
                    viewpointNames.push({
                        'viewpoint_id' : viewpointMaster.viewpoint_id,
                        'name' : viewpointName,
                    })
                }
            }
        }
    }
    return viewpointNames;
}
/**
 * 単元設定から、観点名配点一覧を取得する
 * @param {*} chapter 
 * @param {*} viewpointMasters 
 */
const getViewpointAllotmentsFromQJson = function(chapter, viewpointMasters, isNameVeryShort = false, isMergeGengo = false, isMergeShihanhyou = false)
{
    let viewpointAllotments = [];
    let subjectId = chapter.subject_id;
    let chapterType = chapter.chapter_type;
    let allotmentType = chapter.allotment_type;
    let questionsJson = (null != chapter.questions_json) ? chapter.questions_json : [];
    if(questionsJson.length)
    {
        if((CommonConsts.TEST_TYPE_CUSTOM == chapterType) && (CommonConsts.ALLOTMENT_TYPE_VIEWPOINT_GROUPED == allotmentType))
        {
            // 自作 かつ 観点別単元の場合は設問jsonをそのまま格納
            for(let i = 0; i < questionsJson.length; i++)
            {
                let parentViewpointId = null;
                let viewpointName = '';
                let viewpointId = questionsJson[i].viewpoint_id;
                let viewpoint = viewpointMasters.find(elm => (elm.subject_master_id == subjectId) && (elm.viewpoint_id == viewpointId));
                let vpNo = i + 1;
                if(undefined !== viewpoint)
                {
                    parentViewpointId = viewpoint.parent_viewpoint_id;
                    viewpointName = isNameVeryShort ? viewpoint.name_very_short : viewpoint.name_short;
                }
                viewpointAllotments.push({
                    'viewpoint_id' : viewpointId,
                    'parent_viewpoint_id' : parentViewpointId,
                    'name' : viewpointName,
                    'allotment' : questionsJson[i].allotment,
                    'face' : null, // 自作観点別の場合、裏表情報はnullを格納する
                    'vp_no' : vpNo,
                })
            }
        }
        else
        {
            // 旧実装

            // 自作 かつ 観点別単元でない場合は設問json内の同観点名を集約してまとめて格納
            // let viewpointNames = getViewpointNamesFromQJson(questionsJson, viewpointMasters, isNameVeryShort);
            // for(let i = 0; i < viewpointNames.length; i++)
            // {
            //     let allotments = 0;
            //     if(questionsJson.length)
            //     {
            //         let questions = questionsJson.filter(elm => elm.viewpoint_id == viewpointNames[i].viewpoint_id);
            //         for(let j = 0; j < questions.length; j++)
            //         {
            //             allotments += Number(questions[j].allotment);
            //         }
            //     }
            //     viewpointAllotments.push({
            //         'viewpoint_id' : viewpointNames[i].viewpoint_id,
            //         'name' : viewpointNames[i].name,
            //         'allotment' : allotments,
            //     })
            // }

            // 修正後
            // 表・裏情報も加味して集約すべきであったため、そのように修正する
            // 念のため、上側に修正前の旧実装も残しておく
            let mapVpAllotments = [];
            for(let i = 0; i < questionsJson.length; i++)
            {
                let viewpointId = Number(questionsJson[i].viewpoint_id);
                let parentViewpointId = null;
                let viewpointName = '';
                let viewpoint = viewpointMasters.find(elm => (elm.subject_master_id == subjectId) && (elm.viewpoint_id == viewpointId));
                if(undefined !== viewpoint)
                {
                    parentViewpointId = viewpoint.parent_viewpoint_id;
                    viewpointName = isNameVeryShort ? viewpoint.name_very_short : viewpoint.name_short;
                }
                let allotment = Number(questionsJson[i].allotment);
                let face = Number(questionsJson[i].face);
                let key = String(viewpointId) + '-' + String(face);
                let mapVpAllotment = {
                    'viewpoint_id' : viewpointId,
                    'parent_viewpoint_id' : parentViewpointId,
                    'name' : viewpointName,
                    'allotment' : allotment,
                    'face' : face,
                    'key' : key,
                }
                if(0 == mapVpAllotments.length)
                {
                    // 初回追加
                    mapVpAllotments.push(mapVpAllotment);
                    continue;
                }
                let vpAllotment = mapVpAllotments.find(elm => elm.key == key);
                if(undefined === vpAllotment)
                {
                    // 存在しなければ追加
                    if(mapVpAllotments.length < 3)
                    {
                        mapVpAllotments.push(mapVpAllotment);
                    }
                    else
                    {
                        // 正常に動作すれば、観点名配点一覧の個数は３を超えることはないが、３を超えた時のために処理を記述
                        console.error('観点名配点一覧の取得個数が３を超えています。');

                        // ３を超えたものについては、同じ観点の情報が配列にあれば、そこに配点を加算する。なければ、３を超えたものは切り捨てて処理を行わない。
                        let vp_allotment = mapVpAllotments.find(elm => elm.viewpoint_id == viewpointId);
                        if(undefined !== vp_allotment)
                        {
                            vp_allotment.allotment += allotment;
                        }
                    }
                }
                else
                {
                    // 既に存在していれば、配点を加算していく
                    vpAllotment.allotment += allotment;
                }
            }
            for(let i = 0; i < mapVpAllotments.length; i++)
            {
                let vpNo = i + 1;
                viewpointAllotments.push({
                    'viewpoint_id' : mapVpAllotments[i].viewpoint_id,
                    'parent_viewpoint_id' : mapVpAllotments[i].parent_viewpoint_id,
                    'name' : mapVpAllotments[i].name,
                    'allotment' : mapVpAllotments[i].allotment,
                    'face' : mapVpAllotments[i].face,
                    'vp_no' : vpNo,
                })
            }
        }

        // 教科が国語、かつフラグがオンの際、知・技をまとめる
        if(isMergeGengo && (CommonConsts.SUBJECT_ID_KOKUGO == subjectId))
        {
            viewpointAllotments = mergeParentViewpointId(viewpointAllotments, CommonConsts.VIEWPOINT_ID_KOKUGO_CHIGI, viewpointMasters, isNameVeryShort);
        }
        // 教科が国語、かつフラグがオンの際、思判表をまとめる
        if(isMergeShihanhyou && (CommonConsts.SUBJECT_ID_KOKUGO == subjectId))
        {
            viewpointAllotments = mergeParentViewpointId(viewpointAllotments, CommonConsts.VIEWPOINT_ID_KOKUGO_SHIHANHYOU, viewpointMasters, isNameVeryShort);
        }
    }
    return viewpointAllotments;
}

/**
 * 取得した観点配列一覧を、引数に渡した親観点idでまとめる
 * （例：知・技をまとめる場合は、引数のparentViewpointId = CommonConsts.VIEWPOINT_ID_KOKUGO_CHIGI）
 */
function mergeParentViewpointId(viewpointAllotments, parentViewpointId, viewpointMasters, isNameVeryShort = false)
{
    // マージを行う親観点の観点名を取得
    let parentViewpointName = '';
    let viewpoint = viewpointMasters.find(elm => elm.viewpoint_id == parentViewpointId);
    if(undefined !== viewpoint)
    {
        parentViewpointName = isNameVeryShort ? viewpoint.name_very_short : viewpoint.name_short;
    }

    // 観点配列一覧をループして確認し、観点id, 表裏情報をキーとして集計する
    let afterMergedData = [];
    let vpNo = 0;
    for(let i = 0; i < viewpointAllotments.length; i++)
    {
        if(parentViewpointId == viewpointAllotments[i].parent_viewpoint_id)
        {
            let key = String(viewpointAllotments[i].parent_viewpoint_id) + '-' + String(viewpointAllotments[i].face);
            let result = afterMergedData.find(elm => elm.key == key);
            if(undefined === result)
            {
                // 初回追加
                vpNo++;
                afterMergedData.push({
                    'viewpoint_id' : parentViewpointId,
                    'parent_viewpoint_id' : null,
                    'name' : parentViewpointName,
                    'allotment' : viewpointAllotments[i]['allotment'],
                    'face' : viewpointAllotments[i]['face'],
                    'vp_no' : vpNo,
                    'key' : key,
                })
            }
            else
            {
                // すでに存在する場合は、配点を加算する
                result.allotment += viewpointAllotments[i].allotment;
            }
        }
        else
        {
            let key = String(viewpointAllotments[i]['viewpoint_id']) + '-' + String(viewpointAllotments[i]['face']);
            vpNo++;
            viewpointAllotments[i]['vp_no'] = vpNo;
            viewpointAllotments[i]['key'] = key;
            afterMergedData.push(viewpointAllotments[i]);
        }
    }
    // 変換後のデータからkeyプロパティを削除
    let newArray = [];
    for(let i = 0; i < afterMergedData.length; i++)
    {
        newArray.push({
            'viewpoint_id' : afterMergedData[i].viewpoint_id,
            'parent_viewpoint_id' : afterMergedData[i].parent_viewpoint_id,
            'name' : afterMergedData[i].name,
            'allotment' : afterMergedData[i].allotment,
            'face' : afterMergedData[i].face,
            'vp_no' : afterMergedData[i].vp_no,
        })
    }
    afterMergedData = newArray;
    return afterMergedData;
}

/**
 * 半角数字以外の文字が含まれているかを判断する
 */
const isContainsNonNumeric = function(str)
{
    str = String(str);
    return (str.match(/[^\d-]/) !== null);
}

/**
 * 半角数字以外の文字を削除する
 */
const removeNonNumericChar = function(str)
{
    str = String(str);
    return str.replace(/[^\d-]/g, '');
}

/**
 * タブレット系デバイスかを判断
 */
const isTabletTypeDevice = function()
{
    let result = false;

    // ユーザーエージェントで判定を行う
    const userAgent = navigator.userAgent;
    if(userAgent.match(/iPad|Tablet|Android(?!.*Mobile)/i))
    {
        console.log('device type:tablet');
        result = true;
    }
    return result;
}

/**
 * スマートフォン系デバイスかを判断
 */
const isSmartphoneTypeDevice = function()
{
    let result = false;

    // ユーザーエージェントで判定を行う
    const userAgent = navigator.userAgent;
    if(userAgent.match(/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/i))
    {
        console.log('device type:smartphone');
        result = true;
    }
    return result;
}

/**
 * タブレット系またはスマートフォン系デバイスかを判断
 */
const isTabletOrSmartphoneDevice = function()
{
    let result = false;

    if(isTabletTypeDevice() || isSmartphoneTypeDevice())
    {
        result = true;
    }
    return result;
}

/**
 * 文字列に含まれる半角数字を全角数字に変換
 */
const replaceFullWidthNumber = function(halfNum)
{
    let fullWidthNumbers = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];
    let halfWidthNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    let str = String(halfNum);
    for(let i = 0; i < fullWidthNumbers.length; i++)
    {
        str = str.replace(new RegExp(halfWidthNumbers[i],'g'), fullWidthNumbers[i]);
    }
    return str;
}

/**
 * HTMLからタグを除去してテキストだけにする。
 * @param {*} html HTMLタグ入りテキスト
 */
const removeHtmlTags = function(html)
{
    return html.replace(/<([^'">]|"[^"]*"|'[^']*')*>/g,'')
}

/**
 * 所見の文字数をカウント（改行コードを無視する）
 * @param {*} str 所見文字列
 */
const countFindingChars = function(str)
{
    // 改行コードを除去してカウント
    return str.replace(/\r\n|\r|\n/g, "").length
}

/**
 * 共通定数定義
 */
const CommonConsts = {
    COMMON_INVALID_ID: 0,
    CLASS_ID_INVALID: 0,

    // 学期制
    TERM_KIND_UNKNOWN: 0,           // 未定
    TERM_KIND_2TERMS: 2,            // ２学期制
    TERM_KIND_3TERMS: 3,            // ３学期制

    // 学期
    TERM_YEARLY: 0,
    TERM_1: 1,
    TERM_2: 2,                         
    TERM_3: 3,
    SUMMER_VACATION: 11,
    WINTER_VACATION: 12,
    TERM_CHAPTER_SELECTED: 9, // 「選択単元」項目選択時

    // 教科制限
    MAX_SUBJECT_COUNT: 28,          // 最大教科数
    MAX_CHILD_SUBJECT_COUNT: 5,     // １つの教科が持てる子教科の最大数

    // 教科ID規則
    SUBJECT_ID_INVALID: 0,          // 不正な教科ID
    SUBJECT_ID_KOKUGO: 1,           // 国語
    SUBJECT_ID_SYAKAI: 2,           // 社会
    SUBJECT_ID_SANSUU: 3,           // 算数
    SUBJECT_ID_RIKA: 4,             // 理科
    SUBJECT_ID_SEIKATSU: 5,         // 生活
    SUBJECT_ID_ONGAKU: 6,           // 音楽
    SUBJECT_ID_ZUKOU: 7,            // 図工
    SUBJECT_ID_KATEI: 8,            // 家庭
    SUBJECT_ID_TAIIKU: 9,           // 体育
    SUBJECT_ID_GAIKOKUGO: 90,       // 外国語
    SUBJECT_ID_USER_TOP: 100,       // ユーザー定義教科ID先頭
    SUBJECT_ID_USER_BOTTOM: 199,    // ユーザー定義教科ID終端
    SUBJECT_ID_SCHEDULE: 200,       // 年計表示時の「行事」
    SUBJECT_ID_OTHER: 201,          // 年計表示時の「その他」

    // 観点ID規則
    VIEWPOINT_ID_INVALID: 0,        // 観点：不正な観点ID（他の意味を持つこともある）
    VIEWPOINT_ID_TOTAL_SCORE: 0,    // 観点：総得点
    VIEWPOINT_ID_NONE: 97,          // 観点：観点なし
    VIEWPOINT_ID_GENERAL: 98,       // 観点：総合
    VIEWPOINT_ID_KANITAI: 99,       // 観点：関心・意欲・態度（2024年度現在は「主体的」と表記）
    VIEWPOINT_ID_KOKUGO_CHIGI: 10,  // 観点：知識・技能（国語）
    VIEWPOINT_ID_KANJI: 4,          // 観点：知技（漢字）
    VIEWPOINT_ID_KOTOBA: 5,         // 観点：知技（言葉）
    VIEWPOINT_ID_KOKUGO_SHIHANHYOU: 2,  // 観点：思判表（国語）
    VIEWPOINT_ID_HANASU_KIKU: 6,    // 観点：思判表（話・聞）
    VIEWPOINT_ID_KAKU: 7,           // 観点：思判表（書く）
    VIEWPOINT_ID_YOMU: 8,           // 観点：思判表（読む）
    VIEWPOINT_ID_SYOSYA: 96,        // 観点：書写
    VIEWPOINT_ID_GAKKI: 91,         // 観点：楽器
    VIEWPOINT_ID_KASYOU: 92,        // 観点：歌唱
    VIEWPOINT_ID_CHIGI : 1,         // 観点：知技
    VIEWPOINT_ID_SHIHANHYOU:2,      // 観点：思判表
    VIEWPOINT_ID_EXTENDED_TOP: 201, // 追加観点先頭

    // ロール
    ROLE_TYPE_MANAGER: 2,          // ロール：管理ユーザー
    ROLE_TYPE_TEACHER: 3,          // ロール：一般ユーザー

    // クラス
    MAX_CLASS_COUNT: 100,            // １学校あたりの最大クラス数（てんまるの comMAX_CLASS_COUNT）

    // １クラスあたりの児童数
    DEF_CLASS_STUDENT_COUNT: 20,    // デフォルト
    MAX_CLASS_STUDENT_COUNT: 40,    // 最大（てんまるにあわせる）

    // 評価
    EVALUATION_A: 1,                // A評価
    EVALUATION_B: 2,                // B評価
    EVALUATION_C: 3,                // C評価
    EVALUATION_D: 4,                // D評価
    EVALUATION_E: 5,                // E評価
    EVALUATION_ABSENCE: -2,         // 評価（欠席）
    EVALUATION_EMPTY: 0,            // 評価（未入力）

    // 評定
    RATING_A: 1,                    // A評定
    RATING_B: 2,                    // B評定
    RATING_C: 3,                    // C評定
    RATING_D: 4,                    // D評定
    RATING_E: 5,                    // E評定
    RATING_ABSENCE: -2,             // 評定（欠席）
    RATING_EMPTY: 0,                // 評定（未入力）

    // 使用フラグ
    USE_FLAG_UNUSED: 0,             // 未使用
    USE_FLAG_USED: 1,               // 使用

    // 単元
    MAX_CHAPTER_COUNT: 500,         // １教科あたりの最大単元数（てんまるは1000だが少し控え目）

    // テスト作成形式
    TEST_TYPE_UNUSED: 0,            // 使用しない
    TEST_TYPE_BUNKEI: 1,            // ぶんけいテスト
    TEST_TYPE_CUSTOM: 2,         // 自作テスト

    // 採点データ規則
    MARK_DATA_EMPTY: -1,            // 未入力・空欄
    MARK_DATA_ABSENCE: -2,          // 欠席
    MARK_DATA_UNANSWERED: -3,       // 無答

    // 配点種別
    ALLOTMENT_TYPE_VIEWPOINT_GROUPED : 0, // 観点別
    ALLOTMENT_TYPE_QUESTION_GROUPED : 1,  // 設問別
    ALLOTMENT_TYPE_TOTAL_SCORE : 2,       // 総得点

    // 採点方式
    MARK_TYPE_VIEWPOINT_GROUPED : 0,        // 観点別
    MARK_TYPE_QUESTION_GROUPED : 1,         // 設問別
    MARK_TYPE_TOTAL_SCORE : 2,              // 総得点
    

    // 評価基準確定フラグ
    CRITERIA_NOT_FIXED : 0,   // 評価基準未確定
    CRITERIA_FIXED : 1,       // 評価基準確定

    // 単元採点データロック状態
    CHAPTER_MARK_NOT_COMPLETED : 0,   // 単元採点データ未確定状態
    CHAPTER_MARK_COMPLETED : 1,       // 単元採点データ確定状態

    // 学期採点データロック状態
    TERM_MARK_NOT_COMPLETED : 0,      // 学期採点データ未確定状態
    TERM_MARK_COMPLETED : 1,          // 学期採点データ確定状態

    // カーソルの移動方向（集計表入力）
    CURSOR_DIRECTION_RIGHT_WRAP_BOUNDARY : 0,  // 右（右端で折り返す）
    CURSOR_DIRECTION_RIGHT_WRAP_CHAPTER : 1,   // 右（１単元で折り返す）
    CURSOR_DIRECTION_DOWN : 2,                 // 下
    CURSOR_DIRECTION_UP : 3,                   // 上

    // カーソルの移動方向（観点別入力）
    SINGLE_SIDE_INPUT_IN_ORDER : 0,            // 片面ずつ入力：表面（番号順）→裏面（番号順）
    SINGLE_SIDE_INPUT_REVERSE_ORDER : 1,       // 片面ずつ入力：表面（番号順）→裏面（番号逆順）
    DOUBLE_SIDE_INPUT : 2,                     // 両面を続けて入力
    VP_CURSOR_DIRECTION_DOWN : 3,              // 下
    VP_CURSOR_DIRECTION_UP : 4,                // 上
    VP_CURSOR_DIRECTION_RIGHT : 5,             // 右

    // カーソルの移動方向（学習の記録）
    CURSOR_DIRECTION_RIGHT_WRAP_SUBJECT : 1,   // 右（１教科で折り返す）

    // 入力モード
    MOVE_BY_ENTER : 0,    // Enterで確定して移動
    AUTO_MOVE : 1,        // Enterなしで自動移動

    // 音声読み上げ
    USE_SCORE_VOICE : 0,     // 使用する
    NOT_USE_SCORE_VOICE : 1, // 使用しない

    // 児童転出フラグ
    STUDENT_NOT_EXPORTED : 0,  // 在籍
    STUDENT_EXPORTED : 1,      // 転出

    // テスト表・裏情報
    TEST_FACE_FRONT_SIDE : 0,  // 表
    TEST_FACE_BACK_SIDE : 1,   // 裏

    // 知・技をまとめる設定値
    NOT_MERGE_GENGO : 0,  // まとめない
    MERGE_GENGO : 1,      // まとめる

    // 思判表をまとめる設定値
    NOT_MERGE_SHIHANHYOU : 0, // まとめない
    MERGE_SHIHANHYOU : 1,     // まとめる

    // 未入力の観点の表示設定
    NOT_DISP_EMPTY_VIEWPOINT : 1, // 表示しない
    DISP_EMPTY_VIEWPOINT : 0,     // 表示する

    // 未入力の単元の表示設定
    NOT_DISP_CHAPTER_VIEWPOINT : 1, // 表示しない
    DISP_EMPTY_CHAPTER : 0,     // 表示する

    // 学級平均との差の表示設定
    NOT_DISP_DIFF_CLASS_AVG : 1, // 表示しない
    DISP_DIFF_CLASS_AVG : 0,     // 表示する

    // メモの表示設定
    NOT_DISP_MEMO : 1,           // 表示しない
    DISP_MEMO : 0,               // 表示する

    // 学級平均到達率の表示設定
    NOT_DISP_CLASS_AVG : 1,      // 表示しない
    DISP_CLASS_AVG : 0,          // 表示する

    // 観点別評価の表示設定
    NOT_DISP_VP_EVALUATION : 1,  // 表示しない
    DISP_VP_EVALUATION : 0,      // 表示する

    // 「学習の記録」年間の表示設定
    DISPLAY_TERM_AND_YEAR : 0,   // 学期と年間を表示
    DISPLAY_YEAR_ONLY : 1,       // 年間のみ表示

    // 「学習の記録」評価の表示モード
    EVALUATION_MODE_DEFAULT: 0,  // ABC
    EVALUATION_MODE_MARK: 1,     // 記号

    // 「学習の記録」評定の表示モード
    RATING_MODE_DEFAULT: 0,      // 54321
    RATING_MODE_MARK: 1,         // 記号

    // 「学習の記録」評定段階設定
    RATING_STEPS_5: 5,           // ５段階評定
    RATING_STEPS_3: 3,           // ３段階評定

    // 「学習の記録」前期との比較表示設定
    DISP_PREV_TERM_DIFF: 1,      // 表示する
    NOT_DISP_PREV_TERM_DIFF: 0,  // 表示しない

    // 「学習の記録」変更時のセルの色
    CHANGE_CELL_COLOR_DEFAULT: 0, // デフォルト
    CHANGE_CELL_COLOR_GREEN: 1,   // セルの色を緑に変える

    // 「学習の記録」評定の表示設定
    STUDY_REGISTRY_RATING_HIDE : 1,     // 評定を表示しない
    STUDY_REGISTRY_RATING_NOT_HIDE : 0, // 評定を表示する

    // 「学習の記録」年間評定を個別に設定するかの設定
    RATING_YEAR_SETTING_SEPARATElY : 1,     // 年間評定個別に設定する
    RATING_YEAR_SETTING_NOT_SEPARATElY : 0, // 年間評定個別に設定しない

    // 「学習の記録」評価・評定を半角でコピーする設定
    COPY_VALUE_HANKAKU : 1,     // 半角でコピーする
    COPY_VALUE_NOT_HANKAKU : 0, // 半角でコピーしない

    // 「学習の記録」コピー対象に名前を含める設定
    COPY_VALUE_WITH_NAME : 1,      // 名前を含める
    NOT_COPY_VALUE_WITH_NAME : 0,  // 名前を含めない

    // 「学習の記録」観点表示設定
    DISP_STUDY_REGISTRY_VIEWPOINT : 1,
    NOT_DISP_STUDY_REGISTRY_VIEWPOINT : 0,

    // 「年間の追加観点の評価」設定
    UNIFY_YEAR_EVALUATION : 1,      // 指導要録の観点に統合して表示する
    NOT_UNIFY_YEAR_EVALUATION : 0,  // 学期の評価を表示する

    // 表示微調整値
    SIDE_NAVI_ADUJUST_VALUE: 20,

    // メッセージボックスレベル
    LEVEL_INFO: 1,
    LEVEL_WARN: 2,
    LEVEL_ERROR: 3,

    // カスタムキーパッド値
    CUSTOM_KEYPAD_ENTER: 'customKeypadEnter',          // エンター
    CUSTOM_KEYPAD_CLEAR: 'customKeypadClear',          // クリア
    CUSTOM_KEYPAD_ABSENCE: 'customKeypadAbsence',      // 欠席
    CUSTOM_KEYPAD_FULL_SCORE: 'customKetpadFullScore', // 満点

    // 児童名簿
    MAX_LEN_STUDENT_NAME: 16,   // 最大長：児童名
    MAX_LEN_KOUMU_CODE: 20,     // 最大長：校務管理コード

    // ジョブステータス
    JOB_STATUS_INITIAL : 0,
    JOB_STATUS_PROCESSING : 1,
    JOB_STATUS_SUCCESS : 2,
    JOB_STATUS_ERROR : 9,

    // ※41：通知トリガ
    USER_NOTICE_TRRIGER_LOGIN : 1,          // ログイン時
    USER_NOTICE_TRRIGER_PERIOD : 2,         // 掲載期間

    // ※42：通知方式
    USER_NOTICE_METHOD_MSGBOX : 1,      	// メッセージボックス
    USER_NOTICE_METHOD_LIST : 2,	        // 通知領域

    // ※43：通知内容種別
    USER_NOTICE_TYPE_CHANGE_YEAR : 1,       // 定型：年次更新通知
    USER_NOTICE_TYPE_TEXT : 100,   	        // 任意通知テキスト

    // ※39：所見種別
    FINDING_TYPE_INVALID : 0,               // 所見種別:無効値
    FINDING_TYPE_GENERAL_STUDY : 1,         // 総合的な学習の記録
    FINDING_TYPE_FOREIGN_LANG : 2,          // 外国語活動の記録
    FINDING_TYPE_DOUTOKU : 3,               // 特別の教科　道徳
    FINDING_TYPE_GENERAL_FINDING : 4,       // 総合所見諸事項

    // 所見確定状態
    FINDING_NOT_COMPLETED : 0,
    FINDING_COMPLETED : 1,

    // 所見文字列最大長
    FINDING_MAX_CHARS : 2000,               // 所見文字列最大長（汎用）
}
Object.freeze(CommonConsts);        // プロパティを凍結：書き込み禁止（エラー）になる
export { CommonConsts };

/**
 * 共通メソッド定義
 */
const CommonProcs = {
    SHOW_COMMON_TOOLS: showCommonTools,
    SHOW_SIDE_MENU_BUTTON: showSideMenuButtons,
    MAKE_TERM_NAME: makeTermName,
    MAKE_DB_DATE_TIME: makeDBDateTime,
    ZERO_PADDING: zeroPadding,
    SET_LAST_CLASS_NAME: setLastClassName,
    GET_LAST_CLASS_NAME: getLastClassName,
    SET_LAST_CHAPTER_ID: setLastChapterId,
    GET_LAST_CHAPTER_ID: getLastChapterId,
    SET_LAST_SUBJECT_ID: setLastSubjectId,
    GET_LAST_SUBJECT_ID: getLastSubjectId,
    FORMAT_DATE_TIME: formatDateTime,
    COPY_TEXT_TO_CLIPBOARD: copyText2Clipboard,
    GET_CLIPBOARD_TEXT: getClipboardText,
    EQUALIZE_STR_LINE_BREAKS: equalizeStrLineBreaks,
    CONFIRM_YES_NO_CANCEL: confirmYesNoCancel,
    MESSAGE_BOX: messageBox,
    MESSAGE_BOX_WAIT_CLICK: messageBoxWaitForCloseClick,
    CLOSE_MODAL: closeModal,
    REGISTER_EVENT_LISTENER: registerEventListener,
    GET_SIDE_NAV_WIDTH: getSideNavWidth,
    GET_TERM_NAME: getTermName,
    GET_PUBLISHERS_AND_TESTKINDS: getPublishersAndTestkinds,
    IS_CHAPTERS_MARKS_EXIST: isChaptersMarksExist,
    GET_VP_NAMES_FROM_QJSON: getViewpointNamesFromQJson,
    GET_VP_ALLOTMENTS_FROM_QJSON: getViewpointAllotmentsFromQJson,
    IS_CONTAINS_NON_NUMERIC: isContainsNonNumeric,
    REMOVE_NON_NUMERIC_CHAR: removeNonNumericChar,
    IS_TABLET_TYPE_DEVICE: isTabletTypeDevice,
    IS_SMARTPHONE_TYPE_DEVICE: isSmartphoneTypeDevice,
    IS_TABLET_OR_SMARTPHONE_DEVICE: isTabletOrSmartphoneDevice,
    REPLACE_FULL_WIDTH_NUMBER: replaceFullWidthNumber,
    ADJUST_SIDE_MENU_AREA_SIZE: adjustSideMenuAreaSize,
    REMOVE_HTML_TAGS: removeHtmlTags,
    COUNT_FINDING_CHARS: countFindingChars,
}

Object.freeze(CommonProcs);        // プロパティを凍結：書き込み禁止（エラー）になる
export { CommonProcs };
